import React, { useContext, useEffect, useState } from 'react';
import QuestionBasic from 'components/Organisms/QuestionBasic/QuestionBasic';
import { Loan, LoanDocState, Task, TaskState } from '../../../../../../gql/graphql';
import { TaskContext } from '../Insurance';
import { useCreateResponseTask } from '../../../../../../services/task/mutations';
import ModalFinish from '../ModalFinish';
import { useGetTaskResponsesByTask } from '../../../../../../services/task/querys';
import { OBIE_LOGO } from '../insurance.constant';
import constLogo from '../../../../../../assets/images/constlending-logo.svg';
import { useGetLoanDocByLoan } from 'services/loan/querys';
import { LoanContext } from 'scenes/Private/Dashboard/Dashboard';
import SectionSuccessTask from 'scenes/Private/components/SectionSuccessTask/SectionSuccessTask';

interface Step1Props {
  setStep: Function;
  closeTask: Function;
  responsesStep1?: any;
  optionSelect: any;
  setOptionSelect: any;
}
const Step1 = ({ setStep, closeTask, responsesStep1, optionSelect, setOptionSelect }: Step1Props) => {
  const task: Task | any = useContext(TaskContext);
  const loan: Loan | any = useContext(LoanContext);

  const { data: loanDocs } = useGetLoanDocByLoan({ variables: { loanId: loan._id } });
  const { reexecute: getTaskResponses } = useGetTaskResponsesByTask({
    variables: { findResponsesByTask: { taskId: task._id } },
    pause: true
  });
  const { execute: createResponseTask } = useCreateResponseTask();

  const [modalFinish, setModalFinish] = useState<boolean>(false);

  const isObie = responsesStep1?.find((item: any) => item.key === 'obie')?.key === 'obie';
  const isContact = responsesStep1?.find((item: any) => item.key === 'contact')?.state === TaskState.Approved;
  const isDocument = responsesStep1?.find((item: any) => item.key === 'documents')?.state === TaskState.Approved;
  const isLoanDocApproved = loanDocs?.find(item => item.key === 'insurance')?.state === LoanDocState.Approved;

  const onChangeOption1 = async (option: {
    id: number;
    key: string;
    title: string;
  }) => {
    setOptionSelect(option);

    if ((option.key === 'obie' && !isObie) || (option.key === 'contact' && !isContact) || (option.key === 'documents' && !isDocument)) {
      let newMetadata: any = {};

      if (option.key === 'obie') {
        newMetadata.reviewRename = 'MANUAL ACTION';
        newMetadata.obieOptionSelected = true;
      }
      if (option.key === 'documents') newMetadata.documentOptionSelected = true;

      await createResponseTask({
        key: option.key,
        label: option.title,
        step: 1,
        metadata: newMetadata,
        state: option.key === 'obie' ? TaskState.Review : TaskState.Approved,
        task: task?._id
      });
    }

    if (option.key !== 'obie')
      setStep(2);

    if (option.key === 'obie') {
      setModalFinish(true);
      getTaskResponses({ requestPolicy: 'network-only' });
    }
  };

  return (
    <section>
      <div className="section-1">
        <h3 className="h3">
          You’ll need property and casualty insurance for us to close your loan
        </h3>

        {isLoanDocApproved && task.state === TaskState.Approved && 
          <SectionSuccessTask
            title="You've completed this task."
            button={{ title: "Back to dashboard", onClick: closeTask }}
          />
        }

        <div className="mt-60">
          <QuestionBasic
            type="buttons"
            question={<h3 className="h2 margin-left-0">Would you like an insurance quote from our partner, Obie Insurance?</h3>}
            text={
              <p className="h4 h4-w4">
                If not, you’ll need to give us the contact information for your agent so we can reach out and make sure you’re insured
              </p>
            }
            optionSelected={optionSelect}
            options={[
              {
                id: 1,
                title: 'Get me a quote from Obie',
                title2: `You’ll be redirected to our insurance partner, Obie, to get an estimate. We’ll also email you the link`,
                styleHover: 'option-hover-blue',
                active: isObie,
                disabled: !isObie && isLoanDocApproved,
                icons: [OBIE_LOGO, constLogo],
                onClick: (option: any) =>
                  onChangeOption1({ key: 'obie', ...option })
              },
              {
                id: 2,
                title: 'Contact my insurance agent instead',
                styleHover: 'option-hover-blue',
                active: isContact,
                disabled: !isContact && isLoanDocApproved,
                onClick: (option: any) =>
                  onChangeOption1({ key: 'contact', ...option }),
              },
              {
                id: 3,
                title: 'I’ll upload my own insurance documents',
                styleHover: 'option-hover-blue',
                active: isDocument,
                disabled: !isDocument && isLoanDocApproved,
                onClick: (option: any) =>
                  onChangeOption1({ key: 'documents', ...option }),
              }
            ]}
          />
        </div>
      </div>
      <ModalFinish
        visible={modalFinish}
        setVisible={setModalFinish}
        closeTask={closeTask}
      />
    </section>
  );
};
export default Step1;
